import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import BackButton from 'src/features/navigation/components/BackButton';

export default function StatisticLayout() {
    return (
        <>
            <BackButton />
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
}
